import Home from './Pages/Home';
import Login from './Pages/Login';
import Signup from './Pages/Signup';
import AdminHandoff from './Pages/AdminHandoff';
import ArbitradeBot from '../User/Pages/Account/ArbitradeBot';
import Swapping from './Pages/Swapping';
import Trading from './Pages/Trading';
import Resources from './Pages/Resources';
import Company from './Pages/Company';
import ForexPairs from './Pages/Trading/ForexPairs';
import PreciousMetals from './Pages/Trading/PreciousMetals';
import Energies from './Pages/Trading/Energies';
import Indices from './Pages/Trading/Indices';
import Cryptocurrencies from './Pages/Trading/Cryptocurrencies';
import StdAccount from './Pages/Trading/StdAccount';
import EcnAccount from './Pages/Trading/EcnAccount';
import ProAccount from './Pages/Trading/ProAccount';
import AccountComparison from './Pages/Trading/AccountComparison';
import Leverage from './Pages/Trading/Leverage';
import Pricing from './Pages/Trading/Pricing';
import Academy from './Pages/Resources/Academy';
import Glossary from './Pages/Resources/Glossary';
import MarketInsights from './Pages/Resources/MarketInsights';
import News from './Pages/Resources/News';
import AboutUs from './Pages/Company/AboutUs';
import Regulation from './Pages/Company/Regulation';
import Legal from './Pages/Company/Legal';
import Careers from './Pages/Company/Careers';
import Contact from './Pages/Company/Contact';


const Route = [
    {
        path: '/',
        element: <Home />
    },
        {
        path: '/login',
        element: <Login/>
    },
    {
        path: '/admin-handoff',
        element: <AdminHandoff/>
    },
    {
        path: '/index',
        element: <Home />
    },
     {
        path: '/swap',
        element: <Swapping />
    },
    {
        path: '/trading',
        element: <Trading />
    },
    {
        path: '/trading/forex-pairs',
        element: <ForexPairs />
    },
    {
        path: '/trading/precious-metals',
        element: <PreciousMetals />
    },
    {
        path: '/trading/energies',
        element: <Energies />
    },
    {
        path: '/trading/indices',
        element: <Indices />
    },
    {
        path: '/trading/cryptocurrencies',
        element: <Cryptocurrencies />
    },
    {
        path: '/trading/std-account',
        element: <StdAccount />
    },
    {
        path: '/trading/ecn-account',
        element: <EcnAccount />
    },
    {
        path: '/trading/pro-account',
        element: <ProAccount />
    },
    {
        path: '/trading/account-comparison',
        element: <AccountComparison />
    },
    {
        path: '/trading/leverage',
        element: <Leverage />
    },
    {
        path: '/trading/pricing',
        element: <Pricing />
    },
    {
        path: '/resources',
        element: <Resources />
    },
    {
        path: '/resources/academy',
        element: <Academy />
    },
    {
        path: '/resources/glossary',
        element: <Glossary />
    },
    {
        path: '/resources/market-insights',
        element: <MarketInsights />
    },
    {
        path: '/resources/news',
        element: <News />
    },
    {
        path: '/company',
        element: <Company />
    },
    {
        path: '/company/about',
        element: <AboutUs />
    },
    {
        path: '/company/regulation',
        element: <Regulation />
    },
    {
        path: '/company/legal',
        element: <Legal />
    },
    {
        path: '/company/careers',
        element: <Careers />
    },
    {
        path: '/company/contact',
        element: <Contact />
    },
    {
        path: 'signup/:referralId?',
        element: <Signup />
    }
]
export default Route 